import React from 'react';
import { connect } from 'react-redux';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import DialogCloseButton from '../../../../buttons/DialogCloseButton';
import { createActions } from '../../store';
import CreatePageConstants from '../../CreatePageConstants';
import { randomString } from '../../../../../utilities/randomUtilities';
import { hasSegmentCollision, convertToLyricsTime } from '../../../../../utilities/lyricsUtilities';

const styles = theme => ({
    textArea: {
        width: '100%',
        textAlign: 'center'
    }
});

class LyricsTextDialog extends React.Component {

    state = {
        textValue: ''
    };

    render() {
        const { classes, lyricsTextDialogOpen } = this.props;
        const { textValue } = this.state;

        return (
            <Dialog
                open={lyricsTextDialogOpen}
                onClose={this.onLyricsDialogClose}
                maxWidth='xs'
                fullWidth={true}
                aria-labelledby='text-dialog-title'
            >
                <DialogTitle id='text-dialog-title'>
                    Lyrics
                    <DialogCloseButton onClick={this.onLyricsDialogClose} />
                </DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        className={classes.textArea}
                        value={textValue}
                        onChange={this.onTextAreaChange}
                        label="Paste some text here"
                        multiline
                        rows={15}
                        variant="filled"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.onApplyButtonClick}>
                        Apply
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    onTextAreaChange = (event) => {
        this.setState({
            textValue: event.target.value
        });
    }

    onApplyButtonClick = () => {
        const { textValue } = this.state;
        
        if (textValue && textValue.length > 0) {
            let textLines = textValue.split('\n');

            if (textLines && textLines.length > 0) {
                const { lyricsSegments, lyricsTextDialogInitialTime, addLyricsSegment, audioDuration } = this.props;
                let currentTimePosition = lyricsTextDialogInitialTime;

                for (let i = 0; i < textLines.length; i++) {
                    // If the line doesn't have any characters we add some distance on the timeline
                    let textLine = textLines[i].trim();

                    if (textLine) {
                        let segmentStartTime = convertToLyricsTime(currentTimePosition);
                        let segmentEndTime = convertToLyricsTime(segmentStartTime + CreatePageConstants.LYRICS_TIMELINE.DEFAULT_SEGMENT_DURATION);
                        
                        // If there is collision with existing segment we stop adding
                        if (!hasSegmentCollision(segmentStartTime, segmentEndTime, lyricsSegments, audioDuration)) {
                            addLyricsSegment({
                                id: randomString(),
                                text: textLine,
                                startTime: segmentStartTime,
                                endTime: segmentEndTime
                            });
                            
                            currentTimePosition += CreatePageConstants.LYRICS_TIMELINE.DEFAULT_SEGMENT_DURATION;
                            currentTimePosition += CreatePageConstants.LYRICS_TIMELINE.DEFAULT_SEGMENT_DISTANCE;
                        } else {
                            break;
                        }
                    } else {
                        currentTimePosition += CreatePageConstants.LYRICS_TIMELINE.DEFAULT_SEGMENT_DISTANCE;
                    }
                }
            }
        }

        this.onLyricsDialogClose();
        this.setState({textValue: ''});
    }

    onLyricsDialogClose = () => {
        const { setProperty } = this.props;
        setProperty('lyricsTextDialogOpen', false);
    }
}

const mapStateToProps = (state) => {
    const { segments: lyricsSegments } = state.createPreview.present.videoSettings.lyrics;
    const { 
        lyricsTextDialogOpen,
        lyricsTextDialogInitialTime,
        audioDuration
    } = state.create;

    return {
        lyricsSegments,
        lyricsTextDialogOpen,
        lyricsTextDialogInitialTime,
        audioDuration
    };
}

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(createActions.setProperty(key, value));
    const addLyricsSegment = (newSegment) => dispatch(createActions.addLyricsSegment(newSegment));

    return {
        setProperty,
        addLyricsSegment
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(LyricsTextDialog, styles));